export const getPopupName = (item: any) => {
  return (
    item.name ||
    item.fullname ||
    item.insurance.name ||
    item.insurance ||
    item.title ||
    ""
  );
};
